export const createUiSlice = (set) => ({
  sidebarOpen: false,
  theme: 'ops-dark',
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  setTheme: (theme) => set({ theme })
});